module.exports = __webpack_public_path__ + "static/media/send-message.6e3075f5.svg";